import { useState, useEffect } from 'react'; // useEffect 추가
import './back-top.scss';

const BackTop = () => {
  // Back to Top Active 상태
  const [isActive, setActive] = useState(false);

  useEffect(() => {
    // 스크롤 핸들러 정의
    const handleScroll = () => {
      if (window.scrollY > 125) {
        setActive(true);
      } else {
        setActive(false);
      }
    };

    // 1. 컴포넌트가 마운트될 때 이벤트 리스너 등록
    window.addEventListener('scroll', handleScroll);

    // 2. 컴포넌트가 언마운트될 때 이벤트 리스너 제거 (메모리 누수 및 에러 방지)
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // 빈 배열을 넣어 한 번만 실행되도록 설정

  // 상단으로 이동 함수
  const handleScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <div
        className={`back-to-top ${isActive ? 'active' : ''}`}
        onClick={handleScrollTop}
      >
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.355469 5.95703L5.60547 0.707031M5.60547 0.707031L10.8555 5.95703M5.60547 0.707031V13.832" stroke="white"/>
        </svg>
      </div>
    </>
  );
};

export default BackTop;